import React from "react";

import { Card } from "@jsainsburyplc/id-ui-common";
import { Section } from "@jsluna/section";
import { Account } from "@jsluna/icons";

import { withLinks } from "selectors";

import Locked from "images/icons/locked.js";

const FindOutMoreNectar = () => {
  const { privacyPolicy, helpCentre } = withLinks();

  return (
    <>
      <div className="c-hero">
        <h1 className="ln-u-h2">About My ID</h1>
      </div>
      <Card>
        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">What is My ID?</h2>
          <p>
            My ID is a service that makes accessing and managing your account
            easier.
          </p>
          <p>
            Instead of remembering your Nectar card number, now you only need to
            use your email address and password to log in to Nectar. There’s no
            change in how you collect Nectar points, and you don’t need to get a
            new Nectar card either.
          </p>
          <p>
            If you have a Nectar account and shop at Sainsbury’s online, My ID
            means you can log in to Sainsbury’s using the same email address and
            password you use to access Nectar.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">What are the benefits of My ID?</h2>
          <ul style={{ marginLeft: "0", marginBottom: "0" }}>
            <li className="ln-u-display-flex">
              <span className="ln-u-h6">
                <Account
                  title="Quick and easy login"
                  style={{ color: "#737373" }}
                />
              </span>
              <span className="ln-u-margin-left*2">
                <h3 className="ln-u-h6 ln-u-margin-bottom">
                  Quick and easy login
                </h3>
                <p>
                  We’re introducing a simple email login so you don’t have to
                  remember your Nectar card number anymore. You can also use
                  your Nectar login details to quickly register for Sainsbury’s
                  Groceries if you don’t already have an account.
                </p>
              </span>
            </li>
            <li className="ln-u-display-flex">
              <span className="ln-u-h6">
                <Locked title="Security you can trust" />
              </span>
              <span className="ln-u-margin-left*2">
                <h3 className="ln-u-h6 ln-u-margin-bottom">
                  Security you can trust
                </h3>
                <p>
                  We’ll be rolling out our industry-leading technology, so you
                  can be sure your information will always be safe.
                </p>
              </span>
            </li>
          </ul>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">Does My ID affect my Nectar card?</h2>
          <p>
            No, My ID doesn’t affect your Nectar card. There are no changes in
            how you collect and redeem your points, and there’s no need to get a
            new Nectar card.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">
            I use the same email address on Sainsbury’s Groceries, but different
            Nectar card numbers. Will my points be synced?
          </h2>
          <p>
            No, Nectar cards will not be synced, only login details are shared.
            So the Nectar card linked to your Nectar app and website will remain
            separate from the one you use for Sainsbury’s Groceries.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">
            I don’t know which email address to use for login?
          </h2>
          <p>
            To log in to Nectar, you need to use the email associated with your
            Nectar account. This is the same email address we send your Nectar
            offers to.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">Is my personal data safe?</h2>
          <p>
            Yes, in line with data protection regulations, we’re committed to
            not misusing your personal data. Our{" "}
            <a
              className="ln-c-link findOutMore-privacyLink"
              href={privacyPolicy}
            >
              Privacy and Data policy
            </a>{" "}
            is strict - and we like it that way.
          </p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">Do I have to do anything now?</h2>
          <p>Nothing at all, we’ve already set up everything for you.</p>
        </Section>

        <Section style={{ paddingBottom: "1rem" }}>
          <h2 className="ln-u-h5">Why are we doing this?</h2>
          <p>
            We want to make accessing and managing your account as easy as
            possible. With My ID, you’ll be able to:
          </p>
          <ul style={{ listStyle: "initial", marginBottom: "0" }}>
            <li>
              <p>
                Update your personal details in Nectar and those details
                automatically update in your Sainsbury’s Groceries account if
                you have one
              </p>
            </li>
            <li>
              <p>
                Use your Nectar login details to log in or register to
                Sainsbury’s SmartShop
              </p>
            </li>
          </ul>
        </Section>

        <Section className="ln-u-padding-bottom">
          <h2 className="ln-u-h5">Still have questions about My ID?</h2>
          <p>
            You can visit the{" "}
            <a
              className="ln-c-link findOutMore-helpLink"
              href={`${helpCentre}#myidqueries`}
            >
              Nectar help page
            </a>{" "}
            for more information on the My ID service.
          </p>
        </Section>
      </Card>
    </>
  );
};

export default FindOutMoreNectar;
